import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import { useIntl } from 'react-intl';

/**
 * Table cell for date-time value.
 */
export function TableCellDate({ data }: { data: string }) {
  const { formatDate } = useIntl();

  const label = new Date(data);

  return (
    <Typography title={label.toDateString()} component="div" variant="body1">
      {formatDate(label)}
    </Typography>
  );
}
